import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../../environments/environment';
import { HttpService } from '../../../../../shared/services/http/http-client.service';

const API = environment.url_server;

@Injectable({
  providedIn: 'root'
})
export class ConsultaImportacaoFuncionariosService {

  constructor(private httpService: HttpService) { }


  searchImportEmployee(path: any, data: any, successHandle:Function, errorHandle:Function) {

    this.httpService.doGet('/employee/batch/rows/' + path, data, successHandle, errorHandle);

  }

  searchImportEmployeeStatus(data: any, successHandle:Function, errorHandle:Function) {

    this.httpService.doGet('/employee/batch/rows/status', data, successHandle, errorHandle);

  }
}
